/**
 * Copyright (c) 2025 Adaptive Chaos Labs, LLC
 * All rights reserved.
 */

import axios from 'axios';
import { useAuthStore } from '../store';

const BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 10_000,
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT Bearer token from localStorage on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401 clear auth state and redirect to login
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const requestUrl = String(err?.config?.url ?? '');
    const isChangePasswordEndpoint = requestUrl.includes('/api/auth/me/change-password');

    if (err.response?.status === 401 && !isChangePasswordEndpoint) {
      useAuthStore.getState().clearAuth();
      window.location.href = '/login';
    }
    // Axios always rejects with an `AxiosError`; anything else is wrapped so callers still get an Error.
    return Promise.reject(err instanceof Error ? err : new Error(String(err)));
  },
);

export default api;
